import { Spinner } from '@chakra-ui/react';
import { initReactQueryAuth } from 'react-query-auth';

import history from './history';

import {
  getUserProfile,
  registerWithEmailAndPassword,
  LoginCredentials,
  RegisterCredentials,
  loginWithEmailAndPassword,
  UserResponse,
} from '@/modules/auth';
import { storage, cookies } from '@/utils';

export function setCookies(data: UserResponse) {
  const { accessToken } = data;
  cookies.setAccess(accessToken);
}

export function setCurrentUser(data: UserResponse) {
  const { user } = data;
  storage.setUser(user);

  return user;
}

async function loadUser() {
  try {
    const user = storage.getUser();
    const access = cookies.getAccess();

    if (!user || !access) {
      logoutFn();
      return null;
    }

    if (user) return user;

    if (access) {
      const userFromApi = await getUserProfile();
      return userFromApi;
    }

    return null;
  } catch (error) {
    logoutFn();
    return null;
  }
}

async function loginFn(data: LoginCredentials) {
  const response = await loginWithEmailAndPassword(data);
  setCurrentUser(response);
  setCookies(response);
  return response;
}

async function registerFn(data: RegisterCredentials) {
  const response = await registerWithEmailAndPassword(data);
  const user = setCurrentUser(response);
  return user;
}

async function logoutFn() {
  storage.clearUser();
  cookies.clearAccess();
  history.push('/');
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  LoaderComponent() {
    return <Spinner size="xl" />;
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  any,
  unknown,
  LoginCredentials,
  RegisterCredentials
>(authConfig);
